import { render, staticRenderFns } from "./group_render.vue?vue&type=template&id=526670d3&"
import script from "./group_render.vue?vue&type=script&lang=js&"
export * from "./group_render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526670d3')) {
      api.createRecord('526670d3', component.options)
    } else {
      api.reload('526670d3', component.options)
    }
    module.hot.accept("./group_render.vue?vue&type=template&id=526670d3&", function () {
      api.rerender('526670d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/group_render.vue"
export default component.exports